import React from 'react';
import { Star } from 'lucide-react';

export const RatingSummary = ({ average = 0, count = 0, testId }) => (
  <a href="#customer-reviews" data-testid={testId} className="inline-flex flex-wrap items-center gap-1.5 text-sm text-gray-600 hover:text-orange-600 transition-colors">
    <Star className={`w-4 h-4 ${count ? 'fill-amber-400 text-amber-500' : 'text-gray-400'}`} />
    {count ? <><strong>{Number(average).toFixed(1)}</strong><span>({count} {count === 1 ? 'calificación' : 'calificaciones'})</span></> : <span>Sin calificaciones todavía</span>}
  </a>
);